import { __assign, __rest } from "tslib";
import React from 'react';
import { withBemMod } from '@bem-react/core';
import { cnIcon } from '../Icon';
import './Icon_glyph.css';
import './Icon_glyph_type-arrow.css';
/**
 * Модификатор, отвечающий за символ иконки.
 * @param {IIconGlyphProps} props
 */
export var withGlyphTypeArrow = withBemMod(cnIcon(), { glyph: 'type-arrow' }, function (Icon) { return function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Icon, __assign({}, props, { className: cnIcon({ hasGlyph: true }, [className]) }), props.size === 'xs' ? (React.createElement("svg", { focusable: "false", width: "11", height: "7", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M9.25 1L5.5 4.6 1.75 1 1 1.72 5.5 6 10 1.72 9.25 1z" }))) : (React.createElement("svg", { focusable: "false", width: "13", height: "8", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M11.3 1L6.5 5.7 1.7 1l-.7.7L6.5 7 12 1.7l-.7-.7z" })))));
}; });
